import {
  Typography,
  Skeleton,
  Row,
  Col,
  Form,
  DatePicker,
  Select,
  Descriptions,
  Button,
  Input,
  Popconfirm,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";
import moment from "moment";
import cookie from "react-cookies";
import { toGetEntityList, toGetUsers } from "../Compte/Api";
import {
  toAddDivers,
  toGetCaisseData,
  toGetDivers,
  toPrintExercice,
  toPrintFiche,
  toRemoveDivers,
} from "./APIs";
import { successMsg, toConvertDate } from "../../Utils/Utils";
import Modal from "antd/lib/modal/Modal";
const { Option } = Select;

const Caisse = ({ AppStore, ...props }) => {
  const [data, setData] = useState([]);
  const [marge, setMarge] = useState(0);
  const [date, setDate] = useState(new Date());
  const [end, setEnd] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(-1);
  const [form] = Form.useForm();
  const [formDivers] = Form.useForm();
  const [year, setYear] = useState(new Date().getFullYear());

  const [users, setUsers] = useState([]);
  const [entities, setEntities] = useState([]);
  const [entityId, setEntityId] = useState(-1);
  const [divers, setDivers] = useState([]);
  const [diverOpen, setDiverOpen] = useState(false);

  useEffect(() => {
    formDivers.setFieldsValue({
      note: "",
      value: 0,
      type: "",
    });
    AppStore.setFirst(2);
    AppStore.setSecond(13);
    toGetEntityList().then((res) => {
      setEntities(res);
      if (res.length == 0) {
        toGetUsers().then((users) => {
          setUsers(users);
          if (users.length > 0) {
            setUserId(users[0].id);
            getData(
              moment(date).format("YYYY-MM-DD"),
              moment(end).format("YYYY-MM-DD"),
              users[0].id,
              -1
            );
          }
          setLoading(false);
        });
        return;
      }
      const storedId = cookie.load("entityId");
      const initial = res.find((el) => el.id == storedId)
        ? Number(storedId)
        : res[0].id;
      setEntityId(initial);
      toGetUsers().then((users) => {
        setUsers(users);
        const entity = res.find((el) => el.id == initial);
        const filtered = users.filter((u) => u.entity == entity.title);
        const firstUser = filtered.length > 0 ? filtered[0] : users[0];
        if (firstUser) {
          setUserId(firstUser.id);
        }
        getData(
          moment(date).format("YYYY-MM-DD"),
          moment(end).format("YYYY-MM-DD"),
          firstUser ? firstUser.id : -1,
          initial
        );
        setLoading(false);
      });
    });
  }, []);

  const onChangeEntity = (id) => {
    setEntityId(id);
    const entity = entities.filter((el) => el.id == id)[0];
    const filtered = users.filter((u) => u.entity == entity.title);
    const firstUser = filtered.length > 0 ? filtered[0] : users[0];
    if (firstUser) {
      setUserId(firstUser.id);
    }
    getData(date, end, firstUser ? firstUser.id : -1, id);
  };

  const imprimerExercice = () => {
    setLoading(true);
    toPrintExercice(year, entityId).then((res) => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  };

  const getData = (date, end, l__userId, l__entityId) => {
    setLoading(true);
    setDate(moment(date).format("YYYY-MM-DD"));
    setEnd(moment(end).format("YYYY-MM-DD"));
    toGetDivers(
      moment(date).format("YYYY-MM-DD"),
      moment(end).format("YYYY-MM-DD"),
      l__entityId
    ).then((res) => {
      setDivers(res);
    });
    toGetCaisseData(
      moment(date).format("YYYY-MM-DD"),
      moment(end).format("YYYY-MM-DD"),
      l__userId,
      l__entityId
    ).then((res) => {
      setData(res.list ?? []);
      setMarge(res.marge ?? 0);

      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  };

  const imprimer = () => {
    toPrintFiche(date, end, entityId).then((res) => {});
  };

  const addDiver = () => {
    formDivers.validateFields().then((res) => {
      toAddDivers(res, entityId).then((res) => {
        successMsg("Divers ajoutées avec succées");
        getData(date, end, userId, entityId);
        setDiverOpen(false);
      });
    });
  };
  const disabledDate = (current) => {
    if (!current) return false;
    const year = current.year();
    const currentYear = new Date().getFullYear();
    return year < 2023 || year > currentYear;
  };

  return (
    <>
      <Skeleton active loading={loading} />
      <Form form={form} style={{ marginTop: "2vh" }}>
        <Row className="auto--custom-header">
          <Col span="5">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Typography.Title level={3} style={{ margin: 0 }}>
                CAISSE
              </Typography.Title>
              {entities.length > 0 && (
                <Select
                  value={entityId}
                  style={{ minWidth: "150px" }}
                  onChange={(e) => onChangeEntity(e)}
                >
                  {entities.map((el) => (
                    <Option value={el.id} key={el.id}>
                      {el.title}
                    </Option>
                  ))}
                </Select>
              )}
            </div>
          </Col>
          <Col span="4">
            <Form.Item label="Date">
              <DatePicker.RangePicker
                style={{ width: "100%" }}
                onChange={(e, date) => {
                  getData(date[0], date[1], userId, entityId);
                }}
              />
            </Form.Item>
          </Col>
          <Col span="5">
            <Button
              style={{ marginLeft: "20px" }}
              type="primary"
              onClick={() => imprimer()}
            >
              Imprimer la fiche de caisse
            </Button>
          </Col>
          <Col span="5">
            <Button
              style={{ marginLeft: "20px" }}
              type="primary"
              onClick={() => imprimerExercice()}
            >
              Imprimer l'exercice
            </Button>
            <DatePicker
              picker="year"
              disabledDate={disabledDate}
              onChange={(e) => setYear(moment(e).format("YYYY"))}
            ></DatePicker>
          </Col>
          <Col span="5">
            <Button
              style={{ marginLeft: "20px" }}
              type="primary"
              onClick={() => setDiverOpen(true)}
            >
              Ajouter un divers
            </Button>
          </Col>
        </Row>
      </Form>
      {/* {data.length > 0 && (
        <Row>
          <Col span="24">
            <div style={{ height: 300 }}>
              <ResponsiveContainer>
                <BarChart
                  height={400}
                  data={data}
                  style={{ marginTop: "50px", marginBottom: "2vh" }}
                >
                  <XAxis dataKey="username" fontFamily="Proxima Nova"></XAxis>
                  <Tooltip cursor={{ fill: "transparent" }} />

                  <Bar
                    radius={[2, 2, 0, 0]}
                    dataKey="total"
                    barSize={200}
                    stackId="a"
                    fill="#846eb1"
                    fontFamily="Proxima Nova"
                  >
                    {data.map((entry, index) => (
                      <Cell></Cell>
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      )} */}
      <Descriptions
        column={1}
        bordered
        justify="end"
        size="large"
        style={{ backgroundColor: "white", marginTop: "2vh" }}
      >
        <Descriptions.Item label="espèces" className="item-label">
          {data
            .filter((el) => el.data.type == 0)
            .reduce((a, b) => a + parseFloat(b.data.montant), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="chèques" className="item-label">
          {data
            .filter((el) => el.data.type == 1)
            .reduce((a, b) => a + parseFloat(b.data.montant), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="traites" className="item-label">
          {data
            .filter((el) => el.data.type == 2)
            .reduce((a, b) => a + parseFloat(b.data.montant), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="Carte bancaire" className="item-label">
          {data
            .filter((el) => el.data.type == 3)
            .reduce((a, b) => a + parseFloat(b.data.montant), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="Virement bancaire" className="item-label">
          {data
            .filter((el) => el.data.type == 4)
            .reduce((a, b) => a + parseFloat(b.data.montant), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="retenu à la source" className="item-label">
          {data
            .filter((el) => el.data.type == 5)
            .reduce((a, b) => a + parseFloat(b.data.montant), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="contre remoboursement" className="item-label">
          {data
            .filter((el) => el.data.type == 6)
            .reduce((a, b) => a + parseFloat(b.data.montant), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="Actif" className="item-label">
          {divers
            .filter((el) => el.type == 1)
            .reduce((a, b) => a + parseFloat(b.value), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="Passif" className="item-label">
          {divers
            .filter((el) => el.type == 0)
            .reduce((a, b) => a + parseFloat(b.value), 0)
            .toFixed(3) + " DT"}
        </Descriptions.Item>
        <Descriptions.Item label="Total" className="item-label">
          <b style={{ color: "red", fontSize: "20px" }}>
            {" "}
            {(
              data.reduce((a, b) => a + parseFloat(b.data.montant), 0) +
              divers
                .filter((el) => el.type == 1)
                .reduce((a, b) => a + parseFloat(b.value), 0) -
              divers
                .filter((el) => el.type == 0)
                .reduce((a, b) => a + parseFloat(b.value), 0)
            ).toFixed(3)}
          </b>
        </Descriptions.Item>

        <Descriptions.Item label="Marge Total" className="item-label">
          <b style={{ color: "green", fontSize: "20px" }}>{marge.toFixed(3)}</b>
        </Descriptions.Item>
      </Descriptions>

      <div style={{ margin: "20px" }}>
        <b style={{ fontSize: "20px" }}>Divers</b>
      </div>
      <table className="ant-table" style={{ width: "100%", marginTop: "2vh" }}>
        <thead className="ant-table-thead">
          <tr>
            <th className="ant-table-cell">Date</th>
            <th className="ant-table-cell">Note</th>
            <th className="ant-table-cell">Type</th>
            <th className="ant-table-cell">Valeur</th>
            <th className="ant-table-cell"></th>
          </tr>
        </thead>
        <tbody className="ant-table-tbody">
          {divers.map((el) => (
            <tr>
              <td className="ant-table-cell">
                {toConvertDate(el.dt__createdDate)}
              </td>
              <td className="ant-table-cell">{el.note}</td>
              <td className="ant-table-cell">{el.type ? "Actif" : "Passif"}</td>
              <td className="ant-table-cell">
                {parseFloat(el.value).toFixed(3)}
              </td>
              <td>
                <Popconfirm
                  title={`Voulez vous vraiment supprimer ce divers?`}
                  onConfirm={() =>
                    toRemoveDivers(el.id).then((res) => {
                      getData(date, end, userId, entityId);
                    })
                  }
                  okText="Oui"
                  cancelText="Non"
                >
                  <Button
                    style={{ marginRight: 10 }}
                    icon={<DeleteOutlined />}
                  />
                </Popconfirm>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ margin: "20px" }}>
        <b style={{ fontSize: "20px" }}>Détails</b>
      </div>
      <table className="ant-table" style={{ width: "100%", marginTop: "2vh" }}>
        <thead className="ant-table-thead">
          <tr>
            <th className="ant-table-cell">Date</th>
            <th className="ant-table-cell">Référence BL/Facture</th>
            <th className="ant-table-cell">Total BL/Facture</th>
            <th className="ant-table-cell">Caisse</th>
          </tr>
        </thead>
        <tbody className="ant-table-tbody">
          {data.map((el) => (
            <tr>
              <td className="ant-table-cell">
                {toConvertDate(el.createdDate)}
              </td>
              <td className="ant-table-cell">{el.ref}</td>
              <td className="ant-table-cell">
                {parseFloat(el.data.montant).toFixed(3)}
              </td>
              <td className="ant-table-cell">
                {parseFloat(el.data.montant).toFixed(3)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal
        title="Divers"
        visible={diverOpen}
        onCancel={() => setDiverOpen(false)}
        footer={[
          <Button type="primary" onClick={() => addDiver()}>
            Ajouter divers
          </Button>,
        ]}
      >
        <Form form={formDivers}>
          <Form.Item
            rules={[{ required: true, message: "Champ obligatoire" }]}
            label="Type"
            name="type"
          >
            <Select>
              <Select.Option value="actif">Actif </Select.Option>
              <Select.Option value="passif">Passif </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Champ obligatoire" }]}
            label="Value"
            name="value"
          >
            <Input type="number"></Input>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Champ obligatoire" }]}
            label="Note"
            name="note"
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Caisse;
